import SearchResultsHeader from './SearchResultsHeader';
export default SearchResultsHeader;
